<script setup lang="ts">
const { cart } = useCart();
</script>

<template>
  <div id="cart-totals">
    <table>
      <tbody>
        <tr class="subtotal">
          <th>Sous-total</th>
          <td>{{ currency(cart.totals.subtotal) }}</td>
        </tr>
        <tr class="shipping">
          <th>Expédition</th>
          <td>{{ currency(cart.totals.shipping) }}</td>
        </tr>
        <tr v-for="(couponAmount, couponCode) of cart.totals.coupons" :key="couponCode">
          <th>
            <div class="group flex items-center justify-end gap-1">
              <CartRemoveCoupon :coupon-code="couponCode" />
              <div v-if="couponCode.startsWith('ywpar')" class="text-primary">
                Lillopoints
              </div>
              <div v-else-if="couponCode.startsWith('gift_card_')">
                Carte cadeau
              </div>
              <div v-else>
                Code: <span class="text-primary">{{ couponCode.toUpperCase() }}</span>
              </div>
            </div>
          </th>
          <td>{{ currency(couponAmount) }}</td>
        </tr>
        <tr v-for="(feeAmount, feeLabel) of cart.totals.fees" :key="feeLabel">
          <th>{{ feeLabel }}</th>
          <td>{{ currency(feeAmount) }}</td>
        </tr>
        <tr v-for="(taxAmount, taxLabel) of cart.totals.taxes" :key="taxLabel">
          <th>{{ taxLabel }}</th>
          <td>{{ currency(taxAmount) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="flex flex-col items-end font-bold">
      <span class="text-xl">Grand total</span>
      <span class="text-2xl text-primary">{{ currency(cart.totals.total) }}</span>
    </div>
    <slot name="totals" />
  </div>
</template>

<style lang="postcss">
#cart-totals {
  @apply text-nowrap text-right text-xl space-y-4;
  table {
    @apply w-full;
  }
  .subtotal {
    @apply text-primary ;
  }
  th {
    @apply font-bold pr-4;
  }
}
</style>
